/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AwsEbsSnapshotConvertResult {
  /**
  * ID of the restored EBS snapshot.
  */
  'snapshotId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEbsSnapshotConvertResult.attributeTypeMap;
  }

  public constructor() {
  }
}

